import { convertTemplateToV2 } from "./convertTemplateToV2";

export type SaveTemplateMutationPayload =
  | {
      requestType: "create";
      template: NewNoteOrFormTemplate;
    }
  | {
      requestType: "update";
      template: NoteOrFormTemplate;
    };

const getTemplateFromSchema = (
  schema: NoteSchema | FormSchema,
): NoteOrFormTemplate => {
  if (schema.hasOwnProperty("note_json_schema")) {
    const noteSchema = schema as NoteSchema;

    return {
      id: noteSchema.note_schema_id,
      type: "note",
      title: noteSchema.title ?? "",
      revision: noteSchema.note_schema_revision,
      elements:
        schema.schema_v2?.elements ??
        convertTemplateToV2({
          jsonSchema: noteSchema.note_json_schema,
          uiSchema: noteSchema.note_ui_schema,
        }),
      schemaType: noteSchema.note_schema_type,
    };
  }

  const formSchema = schema as FormSchema;

  return {
    id: formSchema.form_schema_id,
    type: "form",
    formType: formSchema.form_type,
    title: formSchema.title ?? "",
    revision: formSchema.form_schema_revision,
    elements:
      schema.schema_v2?.elements ??
      convertTemplateToV2({
        jsonSchema: formSchema.form_json_schema,
        uiSchema: formSchema.form_ui_schema,
      }),
    schemaType: formSchema.form_schema_type,
  };
};

export default getTemplateFromSchema;
